import { LabMessageGroupDTO } from "@/Common/Api/Labs/Dto/Responses/LabMessageGroupDTO";

class LabMessageGroup {
    public Model: LabMessageGroupDTO;

    public constructor(m?: LabMessageGroupDTO) {
        this.Model = m;
    }
}

export { LabMessageGroup };
